export default {
  common: {
    appName: 'Honey Badger Entertainment',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    submit: 'Enviar',
    save: 'Guardar',
    usernameRequired: '¡Introduzca el nombre de usuario!',
    passwordRequired: '¡Introduzca la contraseña!',
    viewMore: 'Ver más',
    refreshSuccess: 'Actualizado',
    noMore: 'No hay más datos',
    emptyData: 'No hay datos',
  },
  footer: { home: 'Inicio', lottery: 'Lotería', game: 'Reserva', video: 'Vídeo', mine: 'Perfil' },
  lang: { title: 'Idioma / Language', current: 'Idioma actual' },
  home: {
    recommendedTasks: 'Tareas recomendadas',
    popularRanking: 'Ranking de popularidad',
    hotRecommend: 'Recomendaciones populares',
    playCount: 'Reproducciones: {count}',
    noticeLoading: 'Cargando...',
  },
  game: {
    hallTitle: 'Sala de reservas',
    categoryAll: 'Todo',
  },
  choose: {
    title: 'Compañeras',
    tabCities: 'Directorio de ciudades',
    tabProcess: 'Proceso y precios',
    privacyNotice: 'La plataforma con las acompañantes, escorts de negocios y encuentros locales más auténticos de la red. Para proteger la privacidad de cada usuario, el acceso es solo mediante nuestras recepcionistas o la recomendación de un socio veterano verificado.',
    resourcesQ: '¿Qué opciones hay?',
    resourcesA: 'Influencers, modelos, azafatas, modelos jóvenes y universitarias — si lo imaginas, lo conseguimos.',
    scopeQ: '¿Zona de servicio?',
    scopeA: 'Quedadas gratuitas en tu ciudad y desplazamiento a cualquier punto del país. Presentes en todas las grandes ciudades; en ciudades medianas se organiza a través de nuestras recepcionistas.',
    book: 'Reserva',
    contactConcierge: 'Comuníquese con un asesor o recepcionista',
    cityNames: {
      beijing: 'Pekín',
      shanghai: 'Shanghái',
      guangzhou: 'Guangzhou',
      shenzhen: 'Shenzhen',
      nanjing: 'Nankín',
      changsha: 'Changsha',
      chongqing: 'Chongqing',
      xian: 'Xi\'an',
    },
  },
  lottery: {
    gameRecord: 'Historial de tareas',
    orderList: 'Hoja de apuestas',
    orderItemDetail: '1 apuesta X {money} = {money}',
    clearOrder: 'Vaciar hoja',
    confirmSubmit: 'Confirmar y enviar',
    availableBalance: 'Saldo disponible',
    yuan: 'yuan',
    currentPick: 'Selección actual: ',
    amountPerBet: 'Importe por apuesta: ',
    amountPlaceholder: 'Introduce el importe',
    amountInvalid: '¡Importe no válido!',
    fillAmount: '¡Introduce un importe!',
    selectNumberFirst: '¡Selecciona los números!',
    insufficientBalance: 'Saldo insuficiente, ¡contacta con atención al cliente para recargar!',
    notSelected: 'Sin seleccionar',
    contactAdminForTask: '¡Contacta con el administrador para desbloquear esta tarea!',
    drawSuccess: 'Sorteo realizado, periodo: {expect}',
    periodNumber: 'Periodo',
    betUnit: 'apuestas',
    totalAmountLabel: 'Importe total: ',
    totalCountLabel: 'N.º total de apuestas: ',
    drawResult: 'Números sorteados',
    big: 'Grande',
    small: 'Pequeño',
    single: 'Impar',
    doubleNum: 'Par',
    rules: {
      title: 'Cómo jugar',
      tipTitle: 'Cómo apostar',
      tipDetail: 'Elige tus números entre las combinaciones de suma disponibles para realizar una apuesta.',
      winTitle: 'Criterios de premio',
      winDetail: 'Una suma de 11~18 entre los tres números sorteados es Grande; una suma de 3~10 es Pequeño.',
      exampleTitle: 'Ejemplo de apuesta',
      exampleDetail: 'Apuesta: Pequeño. Números sorteados: 123 — resultado: Pequeño.',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'Recarga', withdraw: 'Retiro', game: 'Apuesta' },
    },
    withdraw: {
      amountLabel: 'Importe de la retirada (yuan)',
      all: 'Todo',
      limitRule1: '1. Límite por operación: mínimo {min}, máximo {max}',
      limitRule2: '2. Número de retiradas: hasta {num} retiradas al día',
      limitRule3: '3. Tiempo de abono: normalmente unos 5 minutos, con un mínimo de 2 minutos',
      limitTitle: 'Detalles del límite',
      balanceLabel: 'Saldo: ',
      submit: 'Retirar ahora',
      amountInvalid: 'Introduce un importe válido',
    },
    bindCard: {
      formLabel: 'Introduce los datos de tu tarjeta de cobro',
      bankidLabel: 'Número de tarjeta',
      bankidPlaceholder: 'Introduce el número real de la tarjeta',
      bankLabel: 'Nombre del banco',
      bankPlaceholder: 'Selecciona un banco',
      notice: 'Estimado cliente, para proteger sus fondos, utilice su nombre real y establezca una contraseña de retiro. Si el nombre no coincide con el titular de la cuenta, no será posible retirar.',
      submit: 'Confirmar vinculación',
      bankidRequired: '¡Introduce el número de tarjeta!',
      bankRequired: '¡Selecciona un banco!',
    },
    setbank: {
      title: 'Tarjeta de cobro',
      addCard: 'Añadir tarjeta de cobro',
      tips: 'Nota: vincular una entidad bancaria comercial importante. Si necesita modificarla, contacte con atención al cliente en línea.',
      setNameFirst: '¡Establezca su nombre antes de vincular una tarjeta bancaria!',
      setPayPasswordFirst: '¡Establezca una contraseña de retiro antes de vincular una tarjeta bancaria!',
    },
    setPayPassword: {
      firstPrompt: 'Introduce la contraseña de retiro',
      secondPrompt: 'Vuelve a introducir la contraseña de retiro',
      incomplete: 'Complete todos los campos',
      mismatch: '¡Las dos contraseñas no coinciden!',
    },
    setLoginPassword: {
      oldPassword: 'Contraseña antigua',
      oldPasswordPlaceholder: 'Introduce tu contraseña antigua',
      newPassword: 'Contraseña nueva',
      newPasswordPlaceholder: 'Introduce tu contraseña nueva',
      confirmPasswordPlaceholder: 'Vuelve a introducir tu contraseña nueva',
      incomplete: '¡Complete todos los campos!',
      mismatch: 'Las dos contraseñas no coinciden',
    },
    setname: {
      nameLabel: 'Nombre',
      namePlaceholder: 'Introduce tu nombre real',
      notice: 'Por la seguridad de tu cuenta, el nombre real debe coincidir con el de la tarjeta bancaria vinculada',
      alreadySet: '¡No lo configures repetidamente!',
      nameRequired: '¡Introduce tu nombre!',
    },
    setsex: {
      male: 'Hombre',
      female: 'Mujer',
    },
    infomation: {
      avatar: 'Foto de perfil',
      chooseAvatar: 'Elegir foto de perfil',
      realName: 'Nombre real',
      notSet: 'Sin configurar',
      gender: 'Género',
      unknown: 'Desconocido',
      bindInfo: 'Información de vinculación',
      bound: 'Vinculado',
      none: 'Ninguno',
    },
    index: {
      recharge: 'Depositar',
      withdraw: 'Retirar',
      myWallet: 'Mi cartera',
      details: 'Detalles',
      balanceLabel: 'Saldo: ',
      personalReport: 'Informe personal',
      accountDetail: 'Detalles de la cuenta',
      profileCenter: 'Centro personal',
      notice: 'Anuncios',
      customerService: 'Servicio al cliente',
      completeTaskFirst: 'Complete primero el registro',
      contactServiceToRecharge: 'Contacte al servicio al cliente para depositar',
      setPayoutCardFirst: 'Configure primero su tarjeta de cobro',
      featureDisabled: 'Esta función aún no está disponible',
      accountOffline: 'Cuenta desconectada',
      loginRegister: 'Iniciar sesión / Registrarse',
      loginHint: 'Inicie sesión para verlo',
    },
    setting: {
      basicInfo: 'Información básica',
      loginPassword: 'Contraseña de acceso',
      payPassword: 'Contraseña de pago',
      payPasswordAlreadySet: '¡La contraseña de pago ya está configurada!',
      signOut: 'Cerrar sesión',
    },
    gameRecord: {
      betAmount: 'Importe apostado: {money}',
      betTime: 'Hora de la apuesta: {time}',
      settleTime: 'Hora de liquidación: {time}',
    },
    withdrawRecord: {
      amount: 'Importe del retiro: {money}',
      desc: 'Nota del retiro: {desc}',
      submitTime: 'Hora de la solicitud: {time}',
      reviewTime: 'Hora de la revisión: {time}',
    },
    report: {
      profitLabel: 'Ganancia/Pérdida',
      formulaTip: 'Ganancia/Pérdida = premios - apuestas + depósitos - retiros',
      playAmount: 'Importe apostado',
      rechargeAmount: 'Importe depositado',
      withdrawAmount: 'Importe retirado',
      winAmount: 'Importe ganado',
    },
    service: {
      contact: 'Contactar ahora',
      slogan: 'Puede ponerse en contacto con nosotros en cualquier momento',
    },
  },
  video: {
    hallTitle: 'Cine video',
    hotRecommend: 'Recomendaciones populares',
    playCount: 'Reproducciones: {count}',
    playCountSuffix: '{count} reproducciones',
    rechargeToWatch: '¡Deposite antes de ver los vídeos!',
  },
  recharge: {
    title: 'Recargar',
    chooseCoin: 'Seleccionar moneda',
    address: 'Dirección de depósito',
    copy: 'Copiar dirección',
    copied: 'Copiado',
    amount: 'Importe del depósito',
    uploadShot: 'Subir captura de la transferencia',
    submit: 'Enviar solicitud de recarga',
    pending: 'Pendiente de revisión',
    done: 'Acreditado',
    rejected: 'Rechazado',
  },
  payMethod: {
    title: 'Seleccionar método de cobro',
    bankCard: 'Tarjeta bancaria',
    wallet: 'Monedero cripto',
    unbind: 'Desvincular',
    bindNew: 'Vincular nueva dirección',
    confirmUnbind: '¿Confirmar desvincular este método de cobro?',
    payPassword: 'Contraseña de retiro',
    wrongPassword: 'Contraseña de retiro incorrecta',
    chooseFirst: 'Seleccione primero un método de cobro',
  },
  router: {
    Index: { title: 'Inicio' },
    Home: { title: 'Inicio' },
    Choose: { title: 'Compañeras' },
    List: { title: 'Lista de compañeras' },
    Profile: { title: 'Perfil de compañera' },
    Mine: { title: 'Perfil' },
    Video: { title: 'Vídeo' },
    Game: { title: 'Juegos' },
    Login: { title: 'Iniciar sesión' },
    Register: { title: 'Registro' },
    ServiceOnline: { title: 'Atención al cliente' },
    ServicePage: { title: 'Atención al cliente' },
    Setting: { title: 'Ajustes' },
    Infomation: { title: 'Información básica' },
    Setname: { title: 'Cambiar nombre real' },
    Setsex: { title: 'Cambiar sexo' },
    SetPayPassword: { title: 'Contraseña de pago' },
    SetLoginPassword: { title: 'Contraseña de acceso' },
    Lottery: { title: 'Lotería' },
    Notice: { title: 'Avisos' },
    PlayVideo: { title: 'Reproducir vídeo' },
    Setbank: { title: 'Añadir tarjeta de cobro' },
    BindCard: { title: 'Añadir tarjeta de cobro' },
    Withdraw: { title: 'Retiro' },
    Recharge: { title: 'Recargar' },
    Personalreport: { title: 'Informe personal' },
    WithdrawRecord: { title: 'Historial de retiros' },
    AccountDetail: { title: 'Detalles de cuenta' },
    GameRecord: { title: 'Historial de juegos' },
  },
  captcha: {
    placeholder: 'Captcha de imagen',
    refresh: 'Toca para actualizar',
    error: 'Captcha incorrecto',
    required: 'Introduce el captcha',
  },
  login: {
    title: 'Iniciar sesión',
    usernamePlaceholder: 'Introduzca el nombre de usuario',
    passwordPlaceholder: 'Introduzca la contraseña',
    forgotPassword: '¿Olvidó la contraseña?',
    noAccountRegister: '¿No tiene cuenta? Regístrese ahora',
    submit: 'Iniciar sesión',
  },
  register: {
    title: 'Registro',
    usernamePlaceholder: 'Introduzca el nombre de usuario (6-12 letras o dígitos)',
    passwordPlaceholder: 'Introduzca la contraseña de acceso (6-12 letras o dígitos)',
    codePlaceholder: 'Introduzca el código de invitación',
    protocol: 'He leído y acepto todas las cláusulas del "Acuerdo de apertura de cuenta"',
    submit: 'Registro',
    codeRequired: '¡Introduzca el código de invitación!',
    agreementRequired: '¡Marque la casilla para aceptar el acuerdo de apertura de cuenta!',
  },
}
